import { __commonJSMin as e } from "../../../../../../../../_virtual/_rolldown/runtime.js";
import { require_dist as t } from "../../../../../../@braintree_sanitize-url@7.0.2/bundled_deps/@braintree/sanitize-url/dist/index.js";
//#region ../../node_modules/.pnpm/@intercom+intercom-sanitizer@3.0.0_@braintree+sanitize-url@7.0.2_isomorphic-dompurify@2.34.0/node_modules/@intercom/intercom-sanitizer/dist/url/sanitizer.js
var n = /* @__PURE__ */ e(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 }), e.sanitizeUrl = r;
	var n = t();
	function r(e) {
		return e && (0, n.sanitizeUrl)(e);
	}
}));
//#endregion
export default n();
export { n as require_sanitizer };
